export default {"src":"/_next/static/media/front-yard.52531753.svg","height":23,"width":21,"blurWidth":0,"blurHeight":0};